module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_map-752535b4c2c4742600142848480d5791.svg";